import { render } from "./CodeBlock.vue?vue&type=template&id=d8f008da&scoped=true"
import script from "./CodeBlock.vue?vue&type=script&lang=js"
export * from "./CodeBlock.vue?vue&type=script&lang=js"

import "./CodeBlock.vue?vue&type=style&index=0&id=d8f008da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f008da"]])

export default __exports__